module.exports = __webpack_public_path__ + "static/access_control-32ef6145fc2eddec94c68db5fe11cb85.jpg";